import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "record-event fixed bottom-5 right-10 rounded-full bg-red-500" }
const _hoisted_2 = { class: "flex items-center justify-center p-2 w-20 h-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_icon, {
        name: "hi-microphone",
        class: "text-white animate-pulse",
        scale: 2
      })
    ], 512), [
      [_vShow, _ctx.recording]
    ])
  ]))
}